import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-location-callout.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import { tuftsCard } from '../tufts-card/tufts-card';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The tuftsLocationCallout component
 * @element tufts-location-callout
 *
 * @slot title
 * @slot map
 * @slot location
 * @slot phone
 * @slot time
 * @slot location-details
 * @slot link-button
 * @slot get-directions
 */
@customElement('tufts-location-callout')
export class tuftsLocationCallout extends tuftsCard {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];

  firstUpdated(): void {
    this.checkParentNodeContainer();
  }

  render(): TemplateResult {
    const classes = {
      'main-wrapper ': true,
      [`${this.setColorTemplate()}`]: true,
      'mobile': this.resizeController.currentBreakpointRange === 0,
    };
    return html`
      <article class="${classMap(classes)}">
        ${this.ngSlot.conditionalNGSlot('title', true, 'lg')}
        ${this.ngSlot.conditionalNGSlot('map', false)}
        <div class="content">
          ${this.ngSlot.conditionalNGSlot('location')}
          ${this.ngSlot.conditionalNGSlot('phone')}
          ${this.ngSlot.conditionalNGSlot('time')}
          ${this.ngSlot.conditionalNGSlot('location-details')}
          ${this.ngSlot.conditionalNGSlot('icon-links', false)}
          ${this.ctaTemplate2('get-directions', this.setColorTemplate())}
        </div>
      </article>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-location-callout': tuftsLocationCallout;
  }
}
